<template>
  <div>
    <div class="header_box">
      <keep-alive>
        <headerSearch :index=searchKeyWorld :value=headerValue  @searchNewWord='searchNewWord'></headerSearch>
      </keep-alive>
    </div>
    <div class="content_search">
      <div class="drop_menu">
        <dropDownMenu @getNode='getStatistical' :statisticalList=statistical_List></dropDownMenu>
      </div>
      <div class="search_content">
        <filter-condition @deleteType='deleteType'  @changeSort='changeSort' ref="condition" :sort='searchType.sort' :total=resultTotal :index=searchKeyWorld></filter-condition>
        <div class="search_result">
          <listView @select='getDetail' :dataList='result' :total=resultTotal @readMoreList='readMoreList'></listView>
        </div>
        <div class="no_data" v-if="!result">暂无数据……</div>
      </div>
    </div>
    <div class="totop_icon" @click.stop="backTop" v-if="topShow">
      <img src="../static/img/backTop.png" alt=""/>
    </div>
  </div>
</template>

<script>
  import headerSearch from "./headerSearch";
  import dropDownMenu from "./dropDownMenu";
  import filterCondition from "./filterCondition";
  import listView from "./listView";
  import {_get} from '../api/index.js';
  export default {
    name: "readMore",
    components: {
      headerSearch,
      dropDownMenu,
      filterCondition,
      listView
    },
    data() {
      return {
        date:'',
        source_type:'',
        content_type:'',
        statistical: "",
        searchTypeName: false,
        searchKeyWorld: "",
        result: [],
        statistical_List:{},
        resultTotal:0,
        searchType:{
          index:this.$route.query.index,
          sort:'desc',
          from:0,
          size:10
        },
        menuNode:{},
        headerValue:'1',
        id:0,
        NodeParent:{},
        pageCount:0,
        topShow:false
      };
    },
    created() {
      
    },
    beforeDestroy() {
      document.getElementById('app').removeEventListener('scroll',this.handleTop)
    },
    mounted(){
      document.getElementById('app').addEventListener('scroll',this.handleTop)
      this.$nextTick(()=>{
        this.searchKeyWorld = this.$route.query.index;
        this.id = this.$route.query.id
        this.init()
        this.$refs.condition.initdynamicTags(this.$route.query)
      })
    },
    methods: {
      handleTop(){
        if(document.getElementById('app').scrollTop > 600){
          this.topShow = true
        }
        else{
          this.topShow = false
        }
        //console.log(document.getElementById('app').scrollTop)
      },
      backTop(){
        var body = document.getElementById('app');
        var speed = (body.scrollTop / 100) * 10
        var timer = setInterval(()=>{
          body.scrollTop  = body.scrollTop - speed
          if(body.scrollTop == 0 && body.scrollTop<speed){
            clearInterval(timer)
          }
        },20)
        //console.log(document.getElementById('app').scrollTop)
      },
      init(){
        //console.log(this.$route.query)
        this.$route.query.sort = 'desc'
        this.$route.query.from = 0
        this.$route.query.size = 10
        for(var i in this.$route.query) {
          //console.log(i,":",this.$route.query[i]);
          if(this.$route.query[i] != ''){
            this.searchType[i] = this.$route.query[i]
          }
        }
        //console.log(this.searchType)
        this.search()
      },
      getStatistical(statistical,Nodepath,searchGroup) {
        this.menuNode = statistical
        this.NodeParent = statistical.parent
        //console.log(this.menuNode)
        this.statistical = statistical.data.key;
        //console.log(searchGroup)
        var key = ''
        for(var i in this.searchType){
          //console.log(this.searchType[i])
          if(i != 'index' && i != 'from' && i != 'sort' && i != 'size' && i != 'type' && this.searchType[i].indexOf(Nodepath)>-1){
            var a = this.searchType[i]
            var temp = a.split('-')
            for(var j = 0;j<temp.length;j++){
              this.$refs.condition.deleteTag(temp[j])
            }
          }
        }
        switch(searchGroup){
          case 'date' :  
            key = 'date';
            if(Nodepath.indexOf('小时内') > -1){
              Nodepath = Nodepath.replace(/小时内/,"h")
            }
            else if(Nodepath.indexOf('天内') > -1){
              Nodepath = Nodepath.replace(/天内/,"d")
            }
            else if(Nodepath.indexOf('年内') > -1){
              Nodepath = Nodepath.replace(/年内/,"y")
            }  
            this.searchType[key] = Nodepath;
            this.date= Nodepath;
            break;
          case 'source_type' :  key = 'source_type'; this.searchType[key] = Nodepath;this.source_type= Nodepath;break;
          case 'content_type' :  key = 'content_type'; this.searchType[key] = Nodepath;this.content_type= Nodepath;break;
        }
        this.$refs.condition.addCondition(this.menuNode, searchGroup)
        //console.log(this.statistical)
        //this.$router.query = this.searchType
        this.searchType.sort = 'desc'
        this.searchType.from = 0
        this.searchType.size = 10
        this.searchNewType(this.searchType)
      },
      searchMore() {
        this.$router.push({
          //你需要接受路由的参数再跳转
          path: "/contentnamemore"
        });
      },
      getDetail(id,lx,urls) {
        //console.log(urls)
        if(lx.indexOf('视频') > -1){
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/contentsearch/contentDetail",
            query:{id:id,url:urls,type:this.type} 
          });
        }
        else{
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/contentsearch/contentDetail",
            query:{id:id} 
          });
        }
      },
      search() {
        var url =''
        if(this.searchType.type){
          url = 'reporters/'+this.$route.query.id+'/contents'
        }else {
          url = 'medias/'+this.$route.query.id+'/contents'
        }
        _get(url,this.searchType).then(res => {
          //console.log(res);
          this.resultTotal = res.data.data.total
          this.result = res.data.data.dataList;
          this.statistical_List = res.data.data.statistical
          //console.log(this.resultTotal)
          //console.log(this.result)
          //console.log(this.statistical_List);
        }).catch((res)=>{
          console.log(res)
        });
      },
      searchNewType(searchType){
        this.searchType.from = 0
        this.searchType.size = 10
        this.pageCount = 0
        var url =''
        if(this.searchType.type){
          url = 'reporters/'+this.$route.query.id+'/contents'
        }else {
          url = 'medias/'+this.$route.query.id+'/contents'
        }
        _get(url,this.searchType).then(res => {
          //console.log(res);
          this.resultTotal = res.data.data.total
          this.result = res.data.data.dataList;
          this.statistical_List = res.data.data.statistical
          //console.log(this.statistical_List);
        }).catch((res)=>{
          console.log(res)
        });
        this.$router.push({
          //你需要接受路由的参数再跳转
          path: "/readmore",
          query:{ 
            index:this.searchKeyWorld,
            address:this.searchType.address,
            madia:this.searchType.media,
            date:this.searchType.date,
            type:this.searchType.type,
            id:this.id,
            source_type:this.searchType.source_type,
            content_type:this.searchType.content_type,
            sort:'desc',from:0,size:10
            }
        });
      },
      searchNewWord(newWords,value) {
        //console.log(newWords)
        ///console.log(value)
        let storage = window.localStorage
        let address = storage.getItem('address')
        switch(value){
          case '1':this.$router.push({//你需要接受路由的参数再跳转
              path: '/contentsearch',
              query:{index:newWords,sort:'desc',from:0,size:10,address:address}
          });
          location.reload();
          break;
          case '2':this.$router.push({//你需要接受路由的参数再跳转
              path: '/pressMedia',
              query:{index:newWords,from:0,size:10,address:address}
          });
          location.reload();
          break;
          case '3':this.$router.push({//你需要接受路由的参数再跳转
              path: '/editorReporter',
              query:{index:newWords,from:0,size:10,address:address}
          });
          location.reload();
          break;
          case '4':this.$router.push({//你需要接受路由的参数再跳转
            path: '/contentName',
            query:{index:newWords,type:'person',sort:'desc',from:0,size:10,address:address}
          });
          location.reload();
          break;
          case '5':this.$router.push({//你需要接受路由的参数再跳转
            path: '/contentDepartment',
            query:{index:newWords,type:'organization',sort:'desc',from:0,size:10,address:address}
          });
          location.reload();
          break;
          case '6':this.$router.push({//你需要接受路由的参数再跳转
            path: '/contentSites',
            query:{index:newWords,type:'address',sort:'desc',from:0,size:10,address:address}
          });
          location.reload();
          break;
        }
        if(this.handleValue === value){
          location.reload()
        }
      },
      deleteType(tag){
        //console.log(tag)
        for(var i in this.searchType){
          //console.log(i,':',this.searchType[i])
          if(i != 'index' && i != 'from' && i != 'sort' && i != 'size' && i != 'type' && i != 'id'){
            var temp = this.searchType[i]
            // console.log(temp)
            // console.log(tag)
            if(temp.indexOf(tag) > -1 ){
              var a = temp
              a = a.split('-')
              var b = a.indexOf(tag)
              if(b > -1){
                var k = a.slice()
                for(var j = b+1;j < a.length;j++){
                  this.$refs.condition.deleteTag(k[j])
                }
                k.splice(b,k.length - b)
                a = k
              }
              this.searchType[i] = a.join('-')
              if(this.searchType[i] == ''){
                delete this.searchType[i]
              }
              break;
            }
            if(tag.indexOf('小时')>-1 || tag.indexOf('年')>-1 || tag.indexOf('天')>-1){
              if(temp.indexOf('h')>-1 || temp.indexOf('y')>-1 || temp.indexOf('d')>-1){
                delete this.searchType[i]
                break;
              }
            }
          }
        }
        this.searchType.sort = 'desc'
        this.searchType.from = 0
        this.searchType.size = 10
        this.searchNewType(this.searchType)
        this.menuNode = {}
      },
      changeSort(){
        //console.log(tabPosition)
        if(this.searchType.sort == 'desc'){
          this.searchType.sort = 'asc'
        }else if(this.searchType.sort == 'asc'){
          this.searchType.sort = 'desc'
        }
        this.searchNewType()
      },
      readMoreList(){
        //debugger
        this.pageCount ++
        var url = ''
        if(this.searchType.type){
          url = 'reporters/'+this.$route.query.id+'/contents'
          this.searchType.from  = this.pageCount * this.searchType.size
          _get(url,this.searchType).then(res => {
            for(var i =0;i<res.data.data.dataList.length;i++){
              this.result.push(res.data.data.dataList[i]);
            }
          }).catch((res)=>{
            console.log(res)
          });
        }else {
          url = 'medias/'+this.$route.query.id+'/contents'
          this.searchType.from  = this.pageCount * this.searchType.size
          _get(url,this.searchType).then(res => {
            for(var i =0;i<res.data.data.dataList.length;i++){
              this.result.push(res.data.data.dataList[i]);
            }
          }).catch((res)=>{
            console.log(res)
          });
        }
        
      }
    },
    watch:{
      menuNode(newVal,oldVal){
        // if(oldVal.data && newVal.data){
        //   if(newVal.data.key != oldVal.data.key && newVal.isLeaf === oldVal.isLeaf && newVal.level === oldVal.level){
        //     this.$refs.condition.handleClose(oldVal.data.key)
        //   }
        // }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header_box {
    display: flex;
  }
  .content {
    padding: 20px;
  }
  .content_search {
    height: 100%;
    width: 1200px;
    margin: 20px auto;
  }
  .drop_menu {
    width: 327px;
    height: 80%;
    float: left;
    box-sizing: border-box;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    border-radius: 6px 0px 0px 6px;
    background: rgba(255, 255, 255, 1);
  }
  .search_content {
    width: 853px;
    height: 80%;
    float: right;
    box-sizing: border-box;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    border-radius: 0px 0px 6px 0px;
    background: rgba(255, 255, 255, 1);
  }
  .search_result {
    max-height: 750px;
    overflow-y: auto;
    padding: 10px;
  }
  .result_item {
    padding: 8px 0;
    border-bottom: 1px dotted #eee;
  }
  .item_title {
    font-family: 思源黑体;
    font-size: 16px;
    color: #666;
  }
  .item_img img {
    margin-top: 10px;
    height: 60px;
  }
  .search_box {
    padding: 20px 20px 0 20px;
  }
  .search_box span {
    width: 130px;
    height: 18px;
    font-size: 18px;
    font-family: 思源黑体;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 16px;
  }
  .search_box_item {
    width: 80px;
    height: 40px;
    display: inline-table;
    margin-top: 10px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
  }
  .no_data{
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .totop_icon{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    float: right;
    background-color: #CCC;
    border-radius: 3px;
    position: fixed;
    bottom: 9%;
    right: 12%;
    cursor: pointer;
  }
  .totop_icon:hover{
    background-color: #999999;
  }
  .totop_icon img{
    width: 20px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/readMore.vue